import React, { Component } from 'react'
import './styles.css'
import { Formik, Field, Form } from 'formik'
import { apiEmployee } from '../../services/apiamrg'
import Header from '../../components/header'
import { connect } from 'react-redux'
import { Redirect, Link } from 'react-router-dom'
import { NOME_EMPRESA, PRECISA_LOGAR } from '../../config'
import moment from 'moment'
import Util from '../../classes/util'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControl from '@material-ui/core/FormControl'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Formlabel from '@material-ui/core/FormLabel'
import Select from 'react-select'
import makeAnimated from 'react-select/animated';
import { confirmAlert } from 'react-confirm-alert'
import 'react-confirm-alert/src/react-confirm-alert.css'
import DatePicker from 'react-date-picker';
import { Dots, Squares } from "react-activity";
const estadoInicial = {
    loading: false,
    baseprodutos: [],
    redirect: false,
    produtoscardapio: [],
    empresas: [],
    empresaselecionada: [],
    textoFiltroEmpresa: '',
    tipos: [
        {
            value: 34,
            label: 'BALCÃO DOS SABORES 1'
        },
        {
            value: 46,
            label: 'BALCÃO DOS SABORES 2'
        },
        {
            value: 47,
            label: 'BALCÃO DOS SABORES 3'
        },
        {
            value: 48,
            label: 'BALCÃO DOS SABORES 4'
        },
        {
            value: 49,
            label: 'BALCÃO DOS SABORES 5'
        },
        {
            value: 50,
            label: 'BALCÃO DOS SABORES 6'
        },
        {
            value: 35,
            label: 'BUFFET'
        },
        {
            value: 36,
            label: 'LIGHT 1'
        },
        {
            value: 51,
            label: 'LIGHT 2'
        },
        {
            value: 52,
            label: 'LIGHT 3'
        },
        {
            value: 53,
            label: 'LIGHT 4'
        },
        {
            value: 54,
            label: 'LIGHT 5'
        },
        {
            value: 55,
            label: 'LIGHT 6'
        },
        {
            value: 56,
            label: 'CEIA 1'
        },
        {
            value: 57,
            label: 'CEIA 2'
        },
        {
            value: 60,
            label: 'CEIA 3'
        },
        {
            value: 58,
            label: 'DESJEJUM 1'
        },
        {
            value: 59,
            label: 'DESJEJUM 2'
        },
        {
            value: 37,
            label: 'GRELHADO 1'
        },
        {
            value: 61,
            label: 'GRELHADO 2'
        },
        {
            value: 62,
            label: 'GRELHADO 3'
        },
        {
            value: 63,
            label: 'GRELHADO 4'
        },
        {
            value: 64,
            label: 'GRELHADO 5'
        },
        {
            value: 40,
            label: "CARDAPIO 1"
        },
        {
            value: 41,
            label: "CARDAPIO 2"
        },
        {
            value: 42,
            label: "CARDAPIO 3"
        },
        {
            value: 43,
            label: "CARDAPIO 4"
        },
        {
            value: 44,
            label: "CARDAPIO 5"
        },
       


    ],
    dias_da_semana: [{ label: 'Domingo', value: 1 }, { label: 'Segunda-Feira', value: 2 }, { label: 'Terça-Feira', value: 3 }, { label: 'Quarta-Feira', value: 4 }, { label: 'Quinta-Feira', value: 5 }, { label: 'Sexta-Feira', value: 6 }, { label: 'Sabado', value: 7 }],
    tiposelecionado: [],
    data_inicial: new Date(),
    data_final: new Date(),
    produtosselecionados: [],
    diaSelecionado: []


}

class AddShip extends Component {

    state = {
        ...estadoInicial
    }



    componentDidMount = async () => {
        this.baseprodutos()
        await this.empresas()
        if (this.props.location.state.cardapio != undefined) {
            console.log(this.props.location.state.cardapio)
            this.state.dias_da_semana.map(e => {
                if (e.value == this.props.location.state.cardapio.dia_semana) {
                    this.setState({ diaSelecionado: e })
                }
            })
            let tipo = {
                label: this.props.location.state.cardapio.Descricao,
                value: this.props.location.state.cardapio.chave_grupo
            }
            this.setState({ tiposelecionado: tipo, data_inicial: new Date(this.props.location.state.cardapio.data_inicial), data_final: new Date(this.props.location.state.cardapio.data_final) })
            await this.produtoscardapio()
        }

    }

    finalizar = async () => {
        if (this.props.location.state.cardapio != undefined) {
            if (this.state.diaSelecionado.value == undefined) {
                alert('Dia Da Semana Não Selecionada')
            } else {
                if (this.state.produtosselecionados[0] == undefined) {
                    alert('Sem Nenhum Produto Selecionado')
                } else {
                    if (this.state.tiposelecionado.value == undefined) {
                        alert('Sem Nenhum Tipo Selecionado')
                    } else {
                        console.log(this.state.empresaselecionada)
                        if (this.state.empresaselecionada.label != undefined) {
                            this.setState({ loading: !this.state.loading })
                            apiEmployee.post('atualizarcardapio1', {
                                chave: this.props.location.state.cardapio.chave,
                                data_inicial: moment(this.state.data_inicial).format('YYYY-MM-DD'),
                                data_final: moment(this.state.data_final).format('YYYY-MM-DD'),
                                dia_semana: this.state.diaSelecionado.value,
                                chave_empresa: this.state.empresaselecionada.value,
                                chave_grupo: this.state.tiposelecionado.value,
                            }).then(res => {
                                if (res.data == true) {
                                    apiEmployee.post('atualizarcardapio2', {
                                        chave: this.props.location.state.cardapio.chave,
                                    }).then(res => {
                                        if (res.data == true) {
                                            this.state.produtosselecionados.map(prot => {
                                                apiEmployee.post('atualizarcardapio3', {
                                                    chave: this.props.location.state.cardapio.chave,
                                                    chave_produto: prot.value,
                                                }).then(res => {
                                                    if (res.data != true) {
                                                        alert('Falha em salvar o produto:' + prot.label)
                                                    }
                                                })
                                            })
                                            this.setState({ loading: !this.state.loading, redirect: true })
                                        } else {
                                            alert('Falha em nivel2')
                                        }
                                    })

                                } else {
                                    alert('Falha em nivel1')
                                }
                            })
                        } else {
                            alert('Sem Nenhuma Empresa Selecionada 2')
                        }
                    }
                }
            }
        } else {
            console.log('foi no sem cardapio')
            console.log(this.state.diaSelecionado.value)
            if (this.state.diaSelecionado.value == undefined) {
                alert('Dia Da Semana Não Selecionado')
            } else {
                if (this.state.produtosselecionados[0] == undefined) {
                    alert('Sem Nenhum Produto Selecionado')
                } else {
                    if (this.state.tiposelecionado.value == undefined) {
                        alert('Sem Nenhum Tipo Selecionado')
                    } else {
                        if (this.state.empresaselecionada.label == undefined) {
                            alert('Sem Nenhuma Empresa Selecionada')
                        } else {
                            console.log({
                                data_inicial: moment(this.state.data_inicial).format('YYYY-MM-DD'),
                                data_final: moment(this.state.data_final).format('YYYY-MM-DD'),
                                dia_semana: this.state.diaSelecionado.value,
                                chave_empresa: this.state.empresaselecionada.value,
                                chave_grupo: this.state.tiposelecionado.value
                            })
                            apiEmployee.post('salvarcardapioadmin', {
                                data_inicial: moment(this.state.data_inicial).format('YYYY-MM-DD'),
                                data_final: moment(this.state.data_final).format('YYYY-MM-DD'),
                                dia_semana: this.state.diaSelecionado.value,
                                chave_empresa: this.state.empresaselecionada.value,
                                chave_grupo: this.state.tiposelecionado.value,
                            }).then(res => {
                                const chave = res.data
                                if (chave) {
                                    this.state.produtosselecionados.map(prot => {
                                        apiEmployee.post('atualizarcardapio3', {
                                            chave: chave,
                                            chave_produto: prot.value,
                                        }).then(res => {
                                            if (res.data != true) {
                                                alert('Falha em salvar o produto:' + prot.label)
                                                this.setState({ loading: !this.state.loading })
                                                return
                                            }
                                            this.setState({ loading: !this.state.loading, redirect: true })


                                        })
                                    })
                                    console.log(res.data)
                                }
                            }).catch((err) => {
                                alert('Falha em nivel1');



                                console.log(err)


                            }


                            )

                        }

                    }



                }
            }
        }




    }


    filtrarEmpresa = (e) => {
        if (this.state.textoFiltroEmpresa == "") {
            return true
        }

        const text = this.state.textoFiltroEmpresa.toUpperCase();
        return (e.label.toUpperCase().includes(text))
    }


    trocartudo = async (a) => {
        await this.setState({ tiposelecionado: a, produtosselecionados: [], produtoscardapio: [] })
        await this.filtroprodutos()
    }

    baseprodutos = async () => {
        apiEmployee.get('produtosadmin').then(res => {
            this.setState({ baseprodutos: res.data })
            this.filtroprodutos()
        })
    }



    filtroprodutos = () => {
        let prod = this.state.baseprodutos;
        let vetor = []
        prod.map(element => {

            let r = {
                label: element.Descricao, value: element.chave
            }
            vetor.push(r)

        })
        this.setState({ produtoscardapio: vetor })


    }
    produtoscardapio = async () => {
        apiEmployee.post('produtoscardapio', {
            cardapio: this.props.location.state.cardapio.chave
        }).then(res => {
            let vetor = []
            res.data.map(element => {
                let option = {
                    label: element.Descricao, value: element.chave_produto
                }
                vetor.push(option)
            })
            this.setState({ produtosselecionados: vetor })
        })
    }

    empresas = async () => {
        apiEmployee.get('pegartodasempresas').then(res => {

            let vetor = []
            let vetor2 = []
            res.data.map(element => {
                let option = {
                    label: element.Nome, value: element.Chave
                }
                vetor.push(option)
                if (this.props.location.state.cardapio != undefined && element.Chave == this.props.location.state.cardapio.chave_empresa) {
                    console.log('entro aqui')
                    let option2 = {
                        label: element.Nome, value: element.Chave
                    }
                    vetor2 = option2
                }
            })
            this.setState({ empresas: vetor, empresaselecionada: vetor2 })
        })
    }



    render() {
        const validations = []
        validations.push(this.state.ship_name && this.state.ship_name.trim().length >= 3)


        //o formulário só será válido se todas as validações forem verdadeiras, com este reduce implementado
        const validForm = validations.reduce((t, a) => t && a)

        return (
            <div>
                {this.state.redirect &&
                    <Redirect to={'/admin/ships'} />
                }
                <Header voltarShips />

                <div className='titulo100'><span> {this.props.location.state.cardapio ? 'Alterar Cardapio' : 'Criar Cardápio'} </span></div>

                <div className='centrom'>

                    <div className='col-9 row containeralterarcardapio'>
                        <div className='col-12 contcard'>
                            <span> Dia Da Semana</span>
                            <Select value={this.state.diaSelecionado} options={this.state.dias_da_semana} onChange={a => this.setState({ diaSelecionado: a })} />
                        </div>
                        <div className='col-6 contcard'>
                            <span> Tipo</span>
                            <Select value={this.state.tiposelecionado} options={this.state.tipos} onChange={a => this.trocartudo(a)} />

                        </div>

                        <div className='col-6 contcard'>
                            <span> Empresa</span>
                            <Select value={this.state.empresaselecionada} options={this.state.empresas[0] ? this.state.empresas.filter(empresa => this.filtrarEmpresa(empresa)).slice(0, 20) : []} onInputChange={(e) => this.setState({ textoFiltroEmpresa: e })} onChange={a => this.setState({ empresaselecionada: a })} />
                        </div>

                        <div className='col-6 contcard'>
                            <span> Data Inicial</span>
                            <DatePicker
                                onChange={(a) => this.setState({ data_inicial: a })}
                                value={this.state.data_inicial}
                                format="dd-MM-y"
                                maxDate={this.state.data_final}
                            />
                        </div>


                        <div className='col-6 contcard'>
                            <span> Data Final</span>

                            <DatePicker
                                onChange={(a) => this.setState({ data_final: a })}
                                value={this.state.data_final}
                                format="dd-MM-y"
                                minDate={this.state.data_inicial}
                            />
                        </div>


                        <div className='col-12 contcard'>
                            <span> Produtos</span>

                            <Select options={this.state.produtoscardapio} value={this.state.produtosselecionados} isMulti onChange={a => this.setState({ produtosselecionados: a })} />

                        </div>

                        <div className='col-12 contvtt'>
                            <button type='button' onClick={() => this.finalizar()}> {this.props.location.state.cardapio ? 'Alterar Cardapio' : 'Criar Cardápio'}</button>

                            {this.state.loading && <Squares color={'black'} size={40} speed={0.5} />}
                        </div>

                    </div>

                </div>



            </div>
        )

        /*
    
        className={'form-check-input ' + (errors.acceptTerms && touched.acceptTerms ? ' is-invalid' : '')}
        
           return (
            <section className="latest-products spad">
                <div className="container">
                    <div className="product-filter">
                        <div className="row">
                            <div className="col-lg-12 text-center">
                                <div className="section-title">
                                    <h2>Administrador</h2>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div id="contender">
                        <p>Login</p>
                        <p>Senha</p>
                    </div>                
                </div>
        </section> 
        )
        */
    }
}

const mapStateToProps = ({ user, servidor }) => {
    return {
        token: user.token,
        online: servidor.online
    }
}

export default connect(mapStateToProps, null)(AddShip)


/*
carregaPortos = async () => {
    if(this.props.online){
        await api.get(`seaports`, {
            headers: {
                "Authorization": `bearer ${this.props.token}`
            }
        })
        .then(
            response => {this.setState({seaports: response.data})},
            response => this.erroApi(response)
        )
    }else{
        await apiLocal.get(`seaports`, {
            headers: {
                "Authorization": `bearer ${this.props.token}`
            }
        })
        .then(
            response => {this.setState({seaports: response.data})},
            response => this.erroApi(response)
        )
    } 
}

loadData = async (produto) => {
    try{
        if(this.props.online){
            await api.get(`ships/${produto}`, {
                headers: {
                    "Authorization": `bearer ${this.props.token}`
                }
            }).then(async res => {
                await this.setState({seaport_origin: res.data.seaport_orig, seaport_destiny: res.data.seaport_dest, ship_name: res.data.name, id_seaport: res.data.id_seaport, terminal: res.data.terminal, eta: Util.formataData(res.data.ETA), etb: Util.formataData(res.data.ETB), ets: Util.formataData(res.data.ETS), type: res.data.type, dosage: res.data.dosage, full_shipment: res.data.full_shipment, shipment: res.data.shipment, cargo: res.data.cargo, doomed: res.data.doomed, recirculation: res.data.recirculation, status: res.data.status})
            })
        }else{
            await apiLocal.get(`ships/${produto}`, {
                headers: {
                    "Authorization": `bearer ${this.props.token}`
                }
            }).then(async res => {
                await this.setState({seaport_origin: res.data.seaport_orig, seaport_destiny: res.data.seaport_dest, ship_name: res.data.name, id_seaport: res.data.id_seaport, terminal: res.data.terminal, eta: Util.formataData(res.data.ETA), etb: Util.formataData(res.data.ETB), ets: Util.formataData(res.data.ETS), type: res.data.type, dosage: res.data.dosage, full_shipment: res.data.full_shipment, shipment: res.data.shipment, cargo: res.data.cargo, doomed: res.data.doomed, recirculation: res.data.recirculation, status: res.data.status})
            })
        }

    }catch(e){
        alert(e)
    }
}

/*
inserirNavio = async () => {
    if(this.state.id == 0){
        if(this.props.online){
            await api.post(`ships`, {
                ship_name: this.state.ship_name,
                seaport_origin: this.state.seaport_origin,
                id_seaport: this.state.id_seaport,
                seaport_destiny: this.state.seaport_destiny,
                terminal: this.state.terminal,
                agent: this.state.agent,
                eta: this.state.eta,
                etb: this.state.etb,
                ets: this.state.ets,
                type: this.state.type,
                dosage: this.state.dosage,
                full_shipment: this.state.full_shipment,
                shipment: this.state.shipment,
                cargo: this.state.cargo,
                doomed: this.state.doomed,
                recirculation: this.state.recirculation,
                status: this.state.status
            }, {
                headers: {
                "Authorization": `bearer ${this.props.token}`
                }
            }).then(response => {
                if(response.status === 204){
                    alert("Cadastro realizado corretamente!")
                }else{
                    alert("Erro no cadastro! Tente novamente!")
                }
            })
        }else{
            await apiLocal.post(`ships`, {
                ship_name: this.state.ship_name,
                seaport_origin: this.state.seaport_origin,
                id_seaport: this.state.id_seaport,
                seaport_destiny: this.state.seaport_destiny,
                terminal: this.state.terminal,
                agent: this.state.agent,
                eta: this.state.eta,
                etb: this.state.etb,
                ets: this.state.ets,
                type: this.state.type,
                dosage: this.state.dosage,
                full_shipment: this.state.full_shipment,
                shipment: this.state.shipment,
                cargo: this.state.cargo,
                doomed: this.state.doomed,
                recirculation: this.state.recirculation,
                status: this.state.status
            }, {
                headers: {
                "Authorization": `bearer ${this.props.token}`
                }
            }).then(response => {
                if(response.status === 204){
                    alert("Cadastro realizado corretamente!")
                }else{
                    alert("Erro no cadastro! Tente novamente!")
                }
            })
        }
    }else{
        if(this.props.online){
            await api.put(`ships/${this.state.id}`, {
                ship_name: this.state.ship_name,
                seaport_origin: this.state.seaport_origin,
                id_seaport: this.state.id_seaport,
                seaport_destiny: this.state.seaport_destiny,
                terminal: this.state.terminal,
                agent: this.state.agent,
                eta: this.state.eta,
                etb: this.state.etb,
                ets: this.state.ets,
                type: this.state.type,
                dosage: this.state.dosage,
                full_shipment: this.state.full_shipment,
                shipment: this.state.shipment,
                cargo: this.state.cargo,
                doomed: this.state.doomed,
                recirculation: this.state.recirculation,
                status: this.state.status
            }, {
                headers: {
                    "Authorization": `bearer ${this.props.token}`
                }
            }).then(response => {
                if(response.status === 204){
                    alert('Cadastro atualizado!')
                }else{
                    alert("Erro na atualização! Tente novamente!")
                }
            })
        }else{
            await apiLocal.put(`ships/${this.state.id}`, {
                ship_name: this.state.ship_name,
                seaport_origin: this.state.seaport_origin,
                id_seaport: this.state.id_seaport,
                seaport_destiny: this.state.seaport_destiny,
                terminal: this.state.terminal,
                agent: this.state.agent,
                eta: this.state.eta,
                etb: this.state.etb,
                ets: this.state.ets,
                type: this.state.type,
                dosage: this.state.dosage,
                full_shipment: this.state.full_shipment,
                shipment: this.state.shipment,
                cargo: this.state.cargo,
                doomed: this.state.doomed,
                recirculation: this.state.recirculation,
                status: this.state.status
            }, {
                headers: {
                    "Authorization": `bearer ${this.props.token}`
                }
            }
            ).then(response => {
                if(response.status === 204){
                    alert('Cadastro atualizado!')
                }else{
                    alert("Erro na atualização! Tente novamente!")
                }
            })
        }
    }
}
*/